import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=6e8cf98c&scoped=true"
import script from "./accordion.vue?vue&type=script&lang=ts"
export * from "./accordion.vue?vue&type=script&lang=ts"
import style0 from "./accordion.vue?vue&type=style&index=0&id=6e8cf98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8cf98c",
  null
  
)

export default component.exports